// File: cgp-notification-menu.component.ts
// Author: Brandon Shreve
// Date: 10/25/2018
// Desc: Menu to display notifications
// Other Contributors:

import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { config } from '../../../config/config';
import { CgpSnackbarService } from '../cgp-snackbar/cgp-snackbar.service';
import * as moment from 'moment';

@Component({
    selector: 'cgp-notification-menu',
    templateUrl: './cgp-notification-menu.template.html',
    styleUrls: ['./cgp-notification-menu.style.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [CgpSnackbarService]
})

export class CgpNotificationMenuComponent implements OnInit, OnDestroy {
    public notifications = [];
    private readonly notificationTimer = config.notifications.refreshTimer;
    private notificationsRefreshTimer = null;
    private readonly notificationsApiSubscription = null;

    readonly _snackbarDownloadFailureMessage = 'Failed to download document. Please try again.';
    readonly _snackbarDownloadPendingMessage = 'Downloading document...';
    readonly _snackbarAction = 'Dismiss';

    constructor(private readonly cgpSnackbarService: CgpSnackbarService) { }

    ngOnInit() {
        this.fetchNotifications();
        this.startNotificationsRefresh();
    }

    ngOnDestroy() {
        if (this.notificationsApiSubscription) {
            this.notificationsApiSubscription.unsubscribe();
            clearInterval(this.notificationsRefreshTimer);
        }
    }

    startNotificationsRefresh() {
        const timerInterval = this.notificationTimer;

        this.notificationsRefreshTimer = setInterval(function () {
            this.fetchNotifications();
        }, timerInterval * 60000);
    }

    fetchNotifications() {
        // TODO: Add in application specific notification retrieval service
    }

    getUnreadNotificationCount() {
        return this.notifications.filter(notification => notification.read === false).length;
    }

    getUnreadNotificationDisplayString() {
        const unreadNotificationCount = this.getUnreadNotificationCount();
        return (unreadNotificationCount > 99) ? '99+' : unreadNotificationCount.toString();
    }

    updateNotification(notification, state) {
       // TODO: Add in a service call for your application's notifications service
    }

    onMessageClick(notification) {
        // TODO: Add in a service call for your application's document download service
    }

    hasUrl(notification) {
        return notification.hasUrl();
    }

    getFormattedDate(date) {
        return moment(date).format('DD-MMM-YYYY').toUpperCase();
    }

}
